// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".News_news__wrapper__033v8 h3 {\n  text-align: center;\n}\n.News_news__wrapper__033v8 h4 {\n  text-align: center;\n}", "",{"version":3,"sources":["webpack://./src/components/Admin-panel/News/News.module.scss"],"names":[],"mappings":"AAEE;EACE,kBAAA;AADJ;AAGE;EACE,kBAAA;AADJ","sourcesContent":["\n.news__wrapper{\n  h3{\n    text-align: center;\n  }\n  h4{\n    text-align: center;\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"news__wrapper": "News_news__wrapper__033v8"
};
export default ___CSS_LOADER_EXPORT___;
